import { Component } from '@angular/core';
import { versionInfo } from '../../../../environments/version';

@Component({
  selector: 'app-footer',
  standalone: false,

  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
  appVersion = versionInfo.version;
}
